import { useEffect, useState, useRef } from "react";
import { getToken, getUserId, getInizioPeriodo, getFinePeriodo } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {convertiIdNoleggio,convertiValuta,convertiTipoRiparazione,convertiIdInventario,materialeDisponibile,analisiMateriale,sovrapposti,ordinaPerData,convertiTipoStorage} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faPencil, faTrashCan,faCircleInfo,faSpinner } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import {noleggi_off,utenti_off} from "../offline/offline_costanti.js";
/* global $ */

function RiparazioniTabella({datiRip,numeroConto}) {
var docfileheader
var docfile
var docfileheader2
var docfile2
var MAX_WIDTH
var MAX_HEIGHT
var QUALITY
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function TabellaStoricoRiparazioni() {
    const tipoStorag=[{id:1,text:"Storage"},{id:2,text:"Storage + 3 rescue"},{id:3,text:"Assistenza spiaggia"}]
    const allineamento="center"
    useEffect(() => {
        const fetchStorages = async () => {
            $("#gridContainerRepairs").addClass("grid-container-hidden")
            $("#loadingOverlay").show()


            const formattedRows=datiRip.map((row,index) => ({
                id:index,
                repairid:row.repairid,
                data:convertDate(row.repairdate).toISO({ includeOffset: false }),
                nomeKite:row.repairkitename,
                nomeCliente:row.repairclientname,
                costo:row.repaircost,
                valuta:row.repaircostcurrency,
                note:row.repairnotes,
                repairdamagephoto:row.repairdamagephoto,
                repairphoto:row.repairphoto,
                pagato:row.repairadvance,
                tipoRiparazione:row.repairtype,
                urlPhotoDamage:row.repairdamagephotourl,
                urlPhoto:row.repairphotourl,
            }))
            $("#gridContainerRepairs").dxDataGrid({
          dataSource: formattedRows,
        columns: [
          {
            dataField: "data",
            caption: "Data",

            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 3,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          { dataField: "nomeCliente", caption: "Nome cliente", hidingPriority: 7,alignment:allineamento, },
          { dataField: "nomeKite", caption: "Kite", hidingPriority: 2,alignment:allineamento, },
          { dataField: "tipoRiparazione", caption: "Tipo Riparazione", hidingPriority: 4,alignment:allineamento,
              cellTemplate: function (element, info) {
    element.empty();

    const div = $("<div>").text(convertiTipoRiparazione(info.data.tipoRiparazione));

    if (info.data.urlPhotoDamage) {
        const baseURL = window.location.origin; // es: http://localhost:3000 o https://tuosito.com
        const fileURL = info.data.urlPhotoDamage.startsWith("http")
            ? info.data.urlPhotoDamage
            : `${baseURL}${info.data.urlPhotoDamage.startsWith("/") ? "" : "/"}${info.data.urlPhotoDamage}`;

        const icon = $("<i>")
            .addClass("dx-icon-attach dx-link ml-2")
            .attr("title", "Apri foto danno")
            .css("text-decoration", "none")
            .on("click", function (event) {
                event.stopPropagation();
                window.open(fileURL, "_blank");
            });

        div.append(icon);
    }

    element.append(div);
},

              editCellTemplate: function(cellElement,cellInfo) {
                  if ($("#val_tipo").length===0) {
                      $('<div id="val_tipo"></div>').appendTo(cellElement)
                  }
                  let contatore=1
                  let mappaTipi=[]
                  while (convertiTipoRiparazione(contatore)){
                    mappaTipi.push({id:contatore,text:convertiTipoRiparazione(contatore)})
                    contatore+=1
                  }
                  $("#val_tipo").dxSelectBox({dataSource:mappaTipi,valueExpr: 'id',displayExpr: 'text',value:cellInfo.value,searchEnabled: true, onValueChanged: function(e) {
                    cellInfo.setValue(e.value)
                    },
                  })
              }
          },
          {dataField:"costo",alignment:"center",
            hidingPriority:6,
            cellTemplate: function (element, info) {
    element.empty();

    const div = $("<div>").text(`${info.data.costo.toFixed(2)} ${convertiValuta(info.data.valuta)}`);

    if (info.data.urlPhoto) {
        const baseURL = window.location.origin; // es: http://localhost:3000 o https://tuosito.com
        const fileURL = info.data.urlPhoto.startsWith("http")
            ? info.data.urlPhoto
            : `${baseURL}${info.data.urlPhoto.startsWith("/") ? "" : "/"}${info.data.urlPhoto}`;

        const icon = $("<i>")
            .addClass("dx-icon-attach dx-link ml-2")
            .attr("title", "Apri foto riparazione")
            .css("text-decoration", "none")
            .on("click", function (event) {
                event.stopPropagation();
                window.open(fileURL, "_blank");
            });

        div.append(icon);
    }

    element.append(div);
},
            editCellTemplate:function(cellElement,cellInfo){
                if ($("#vendute_valprezzo").length===0) {
                $('<div id="vendute_valprezzo"></div>').appendTo(cellElement)
            }
            $("#vendute_valprezzo").dxNumberBox({showSpinButtons: true,step:10,min:0,value:cellInfo.value,format:`#0.##'${convertiValuta(cellInfo.data.valuta)}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)}
            })}},
            {dataField:"pagato",alignment:"center",hidingPriority:5,

            cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value}{convertiValuta(cellInfo.data.valuta)}
                </div>
            );
          }},
            editCellTemplate:function(cellElement,cellInfo){
                if ($("#vendute_valpagato").length===0) {
                $('<div id="vendute_valpagato"></div>').appendTo(cellElement)
            }
            $("#vendute_valpagato").dxNumberBox({showSpinButtons: true,step:10,min:0,value:cellInfo.value,format:`#0.##'${convertiValuta(cellInfo.data.valuta)}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)}
            })}},
            {dataField:"valuta",

            visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#vendute_valvaluta").length===0) {
                $('<div id="vendute_valvaluta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#vendute_valvaluta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#vendute_valprezzo").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            $("#vendute_valpagato").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            }})
          }},
          { dataField: "note", caption: "Note riparazione", hidingPriority: 1,alignment:allineamento, },
          {
                            dataField: 'repairdamagephoto', visible: false,
                            editCellTemplate: function (cellElement, cellInfo) {
                                $('<div id="attachmentcontentdocument" style="display: inline-block;"></div>').appendTo(cellElement);

                                $('<div id="btncleandocument" class="mr-3"></div>').appendTo($('#attachmentcontentdocument'));
                                $('#btncleandocument').dxButton({
                                    text: "",
                                    icon: 'trash',
                                    onClick: function (e) {
                                        $('#lbldocument').text("");
                                        docfileheader = "";
                                        docfile = "";
                                        $('#btncleandocument').addClass("hidden");
                                        $('#fileuploaddocument').val("");

                                        cellInfo.setValue('');
                                    }
                                });

                                if (cellInfo.data.urlPhotoDamage == undefined || cellInfo.data.urlPhotoDamage == null || cellInfo.data.urlPhotoDamage.length == 0)
                                    $('#btncleandocument').addClass("hidden");

                                $('<div id="btnselectdocument" class="mr-3"></div>').appendTo($('#attachmentcontentdocument'));
                                $('#btnselectdocument').dxButton({
                                    text: "",
                                    icon: 'attach',
                                    onClick: function (e) {
                                        $('#fileuploaddocument').trigger('click');
                                    }
                                });

                                $('<input class="hidden" type="file" id="fileuploaddocument" accept="image/*,application/pdf"/>').on('change', function (event) {
                                    if (event.target.files.length > 0) {
                                        var file = event.target.files[0];
                                        if (file.type.startsWith("image")) {
                                            var blobURL = URL.createObjectURL(file);
                                            var img = new Image();
                                            img.src = blobURL;
                                            img.onerror = function () {
                                                URL.revokeObjectURL(this.src);
                                                alert("Unable to load attachment");
                                            };
                                            img.onload = function () {
                                                URL.revokeObjectURL(this.src);

                                                let width = img.width;
                                                let height = img.height;
                                                if (width > height) {
                                                    if (width > MAX_WIDTH) {
                                                        height = Math.round((height * MAX_WIDTH) / width);
                                                        width = MAX_WIDTH;
                                                    }
                                                } else {
                                                    if (height > MAX_HEIGHT) {
                                                        width = Math.round((width * MAX_HEIGHT) / height);
                                                        height = MAX_HEIGHT;
                                                    }
                                                }

                                                var canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                var ctx = canvas.getContext("2d");
                                                ctx.drawImage(img, 0, 0, width, height);

                                                var base64 = canvas.toDataURL(file.type, QUALITY);
                                                docfileheader = base64.substring(0, base64.indexOf(';base64,') + 8);
                                                docfile = base64.substring(base64.indexOf(';base64,') + 8);

                                                cellInfo.setValue(file.name);
                                                $('#lbldocument').text(file.name);
                                                $('#btncleandocument').removeClass("hidden");
                                            }
                                        }
                                        else {
                                            var fileReader = new FileReader();
                                            fileReader.onload = function (fileLoadedEvent) {
                                                var base64 = fileLoadedEvent.target.result;
                                                docfileheader = base64.substring(0, base64.indexOf(';base64,') + 8);
                                                docfile = base64.substring(base64.indexOf(';base64,') + 8);
                                                cellInfo.setValue(file.name);
                                                $('#lbldocument').text(file.name);
                                                $('#btncleandocument').removeClass("hidden");
                                            };
                                            fileReader.readAsDataURL(file);
                                        }
                                    }
                                }).appendTo($('#attachmentcontentdocument'));

                                $('<div id="lbldocument" style="display: inline-block;"></div>').appendTo($('#attachmentcontentdocument'));
                            }
                        },
          {
                            dataField: 'repairphoto', visible: false,
                            editCellTemplate: function (cellElement, cellInfo) {
                                $('<div id="attachmentcontentdocument2" style="display: inline-block;"></div>').appendTo(cellElement);

                                $('<div id="btncleandocument2" class="mr-3"></div>').appendTo($('#attachmentcontentdocument2'));
                                $('#btncleandocument2').dxButton({
                                    text: "",
                                    icon: 'trash',
                                    onClick: function (e) {
                                        $('#lbldocument2').text("");
                                        docfileheader2 = "";
                                        docfile2 = "";
                                        $('#btncleandocument2').addClass("hidden");
                                        $('#fileuploaddocument2').val("");

                                        cellInfo.setValue('');
                                    }
                                });

                                if (cellInfo.data.urlPhoto == undefined || cellInfo.data.urlPhoto == null || cellInfo.data.urlPhoto.length == 0)
                                    $('#btncleandocument2').addClass("hidden");

                                $('<div id="btnselectdocument2" class="mr-3"></div>').appendTo($('#attachmentcontentdocument2'));
                                $('#btnselectdocument2').dxButton({
                                    text: "",
                                    icon: 'attach',
                                    onClick: function (e) {
                                        $('#fileuploaddocument2').trigger('click');
                                    }
                                });

                                $('<input class="hidden" type="file" id="fileuploaddocument2" accept="image/*,application/pdf"/>').on('change', function (event) {
                                    if (event.target.files.length > 0) {
                                        var file = event.target.files[0];
                                        if (file.type.startsWith("image")) {
                                            var blobURL = URL.createObjectURL(file);
                                            var img = new Image();
                                            img.src = blobURL;
                                            img.onerror = function () {
                                                URL.revokeObjectURL(this.src);
                                                alert("Unable to load attachment");
                                            };
                                            img.onload = function () {
                                                URL.revokeObjectURL(this.src);

                                                let width = img.width;
                                                let height = img.height;
                                                if (width > height) {
                                                    if (width > MAX_WIDTH) {
                                                        height = Math.round((height * MAX_WIDTH) / width);
                                                        width = MAX_WIDTH;
                                                    }
                                                } else {
                                                    if (height > MAX_HEIGHT) {
                                                        width = Math.round((width * MAX_HEIGHT) / height);
                                                        height = MAX_HEIGHT;
                                                    }
                                                }

                                                var canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                var ctx = canvas.getContext("2d");
                                                ctx.drawImage(img, 0, 0, width, height);

                                                var base64 = canvas.toDataURL(file.type, QUALITY);
                                                docfileheader2 = base64.substring(0, base64.indexOf(';base64,') + 8);
                                                docfile2 = base64.substring(base64.indexOf(';base64,') + 8);

                                                cellInfo.setValue(file.name);
                                                $('#lbldocument2').text(file.name);
                                                $('#btncleandocument2').removeClass("hidden");
                                            }
                                        }
                                        else {
                                            var fileReader = new FileReader();
                                            fileReader.onload = function (fileLoadedEvent) {
                                                var base64 = fileLoadedEvent.target.result;
                                                docfileheader2 = base64.substring(0, base64.indexOf(';base64,') + 8);
                                                docfile2 = base64.substring(base64.indexOf(';base64,') + 8);
                                                cellInfo.setValue(file.name);
                                                $('#lbldocument2').text(file.name);
                                                $('#btncleandocument2').removeClass("hidden");
                                            };
                                            fileReader.readAsDataURL(file);
                                        }
                                    }
                                }).appendTo($('#attachmentcontentdocument2'));

                                $('<div id="lbldocument2" style="display: inline-block;"></div>').appendTo($('#attachmentcontentdocument2'));
                            }
                        },
          {
            type: "buttons",
            minWidth:120,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
            ],
          },
          ],
          showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            title: "Modifica Riparazione",
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            onShown: function(e) {
                const $content = $(e.component.content());
                $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
                $("#customScroll").dxScrollView({
                    useNative: true,
                    direction: "vertical",
                    showScrollbar: "onScroll"
                });
                }
            },
          form: {
          items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                        {
                    dataField: "data",
                    label: { text: "Data" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "nomeCliente",
                    label: { text: "Nome cliente" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "nomeKite",
                    label: { text: "Nome Kite" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "tipoRiparazione",
                    label: { text: "Tipo riparazione" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "costo",
                    label: { text: "Costo riparazione" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "valuta",
                    label: { text: "Valuta costo" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "pagato",
                    label: { text: "Pagato" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "repairdamagephoto",
                    label: { text: "Foto danno" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "repairphoto",
                    label: { text: "Foto riparazione" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "note",
                    label: { text: "Note riparazione" }  // ← Etichetta personalizzata
                  },
                ]}
              ]
          }

        },
        onCellClick: function(e) {
            if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
              if (!($icon.length)) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more");
              if ($icon.length){
              $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
              }
              else
              {
              $icon[0].className = "dx-datagrid-adaptive-more";
              }}

        },
        onEditorPreparing: function(e) {
          if (e.parentType === "filterRow" && (e.dataField === "data"||e.dataField === "storageDa"||e.dataField==="storageA")) {

            e.editorName = "dxDateBox";  // Forza DateBox come filtro
            e.editorOptions = {
              displayFormat: "dd/MM/yyyy",
              type: "date",
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
          if (e.parentType === "filterRow" && e.dataField === "tipo") {
            const dataTipo=tipoStorag
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'id',displayExpr: 'text',searchEnabled: true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
        },
        onInitNewRow: function (e) {
        e.data.costo=0;
        e.data.pagato=0;
        e.data.sconto=0;
        e.data.data=DateTime.now().toISODate()
        e.data.valuta=1
        e.data.tipoRiparazione=1
        docfileheader=null
        docfile=null
        docfileheader2=null
        docfile2=null
        },
        onEditingStart: function(e){
            docfileheader=null
        docfile=null
        docfileheader2=null
        docfile2=null
        },
        onRowInserting: async function (e) {
            const gridElement = $("#gridContainerRepairs"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            if (docfileheader != null && docfileheader != "") {
                            e.data.repairdamagephoto= docfile;
                            e.data.repairdamagephotoheader= docfileheader;
                            docfileheader = null;
                            docfile = null;
                        }
            if (docfileheader2 != null && docfileheader2 != "") {
                            e.data.repairphoto= docfile2;
                            e.data.repairphotoheader= docfileheader2;
                            docfileheader2 = null;
                            docfile2 = null;
                        }
            const dati_n={'repairnotes':e.data.note,'repairclientname':e.data.nomeCliente,'repaircost':e.data.costo,'repaircostcurrency':e.data.valuta,'repairadvance':e.data.pagato,'repairkitename':e.data.nomeKite,"repairdate":convertDate(DateTime.fromISO(e.data.data)),"repairtype":e.data.tipoRiparazione,"repairdamagephoto":e.data.repairdamagephoto,"repairdamagephotoheader":e.data.repairdamagephotoheader,"repairphoto":e.data.repairphotoheader,"repairphotoheader":e.data.repairphotoheader};
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati_n,
                azione:'setRepair'})
                if (richiesta) {
                    const message = `Riparazione di ${e.data.nomeCliente} aggiunto con successo`;
                    window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerRepairs',

                        },}, "success", 500);
                    const dati = await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        azione: "getRepairs",
                        filtri:{"billid":numeroConto}
                    })
                    const formattedRows=dati.map((row,index) => ({
                id:index,
                repairid:row.repairid,
                data:convertDate(row.repairdate).toISO({ includeOffset: false }),
                nomeKite:row.repairkitename,
                nomeCliente:row.repairclientname,
                costo:row.repaircost,
                valuta:row.repaircostcurrency,
                note:row.repairnotes,
                repairdamagephoto:row.repairdamagephoto,
                repairphoto:row.repairphoto,
                pagato:row.repairadvance,
                tipoRiparazione:row.repairtype,
            }))
                      $("#gridContainerRepairs").dxDataGrid("instance").option("dataSource",formattedRows)
                }

        },
        onRowUpdated: async function (e) {
            const gridElement = $("#gridContainerRepairs"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            if (docfileheader != null && docfileheader != "") {
                            e.data.repairdamagephoto= docfile;
                            e.data.repairdamagephotoheader= docfileheader;
                            docfileheader = null;
                            docfile = null;
                        }
            if (docfileheader2 != null && docfileheader2 != "") {
                            e.data.repairphoto=docfile2 ;
                            e.data.repairphotoheader= docfileheader2;
                            docfileheader2 = null;
                            docfile2 = null;
                        }
            const dati_n={'repairnotes':e.data.note,'repairclientname':e.data.nomeCliente,'repaircost':e.data.costo,'repaircostcurrency':e.data.valuta,'repairadvance':e.data.pagato,'repairkitename':e.data.nomeKite,"repairdate":convertDate(DateTime.fromISO(e.data.data)),"repairtype":e.data.tipoRiparazione,"repairdamagephoto":e.data.repairdamagephoto,"repairdamagephotoheader":e.data.repairdamagephotoheader,"repairphoto":e.data.repairphotoheader,"repairphotoheader":e.data.repairphotoheader};
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.repairid,
                valori:dati_n,
                azione:'setRepair'})
                if (richiesta) {
                const message = `Riparazione di ${e.data.nomeCliente} modificata con successo`;

                window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerRepairs',

                        },}, "success", 500);
                }
            },
        onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.repairid,
                azione:'delRepair',
                return_data:false})
            if (richiesta) {
                const message = `Riparazione di ${e.data.nomeCliente} eliminata con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerRepairs',

                },}, "success", 500);}
        },

        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainerRepairs").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
          if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));

            const pagato = parseEuro(e.data.pagato);
            const costo = parseEuro(e.data.costo);
            if ((!isNaN(pagato) && !isNaN(costo) && Math.abs(pagato - costo) > 0.01)) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }
        },
          })

        }
        fetchStorages()
    },[])
return (<div id="gridContainerRepairs" ></div>)
}

return (<div>
        <TabellaStoricoRiparazioni/>
        <div id="loadingOverlay">
           <div className="spinner">
              <Lottie  style={{ width: "30%", height: "30%" }} animationData={animLoading} loop={true} />
           </div>
        </div>
        </div>)
}

export default RiparazioniTabella